// @flow
import * as React from 'react';
import { translate } from 'react-i18next';

import Card from 'common/components/Card';
import Proposition from 'common/modules/proposition/domain/proposition';
import PropositionListing from 'common/modules/proposition/domain/propositionListing';
import DataTable from 'common/components/DataTable';
import SalesPropositionRow from './SalesPropositionRow';

type Props = {
  user: Object,
  propositions: PropositionListing[],
  loading?: boolean,

  onClick: (proposition: PropositionListing) => void,
  onChange: (proposition: Proposition) => void,

  t: any,
};

function SalesPropositionTable(props: Props) {
  const { propositions, loading, onClick, user, t, onChange } = props;
  return (
    <Card style={{ height: 'auto' }}>
      <DataTable
        headers={[
          t('diffusion'),
          t('title'),
          t('totalCost'),
          t('salesman'),
          t('customer'),
          t('state'),
          t('actions'),
        ]}

        data={propositions}
        renderRow={proposition =>
          <SalesPropositionRow
            key={proposition.reference}
            user={user}
            proposition={proposition}
            onClick={() => onClick(proposition)}
            onChange={onChange}
          />}

        noDataMessage={t('noProposition')}
        loading={loading}
      />
    </Card>
  );
}

export default translate('sales')(SalesPropositionTable);



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/components/proposition/SalesPropositionTable.js